import Query from '../../../../../components/Report';

export const query = ({ prompt_uids, base_domain, brand }) => {
    return new Query('ai-tracking-reports-prompts', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        base_domain,
        brand,
    });
};

function setKeywordUids(ids) {
    return `prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}
